import { axiosInstance } from "../../axios/axiosInstance";
import { ADMIN_API_URL, API_BASE_URL, getDefaultHeaders } from "../../config";

const authHeaders = (extra = {}) => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
    ...extra,
  };
};

export const getIndustries = () =>
  axiosInstance.get(`${API_BASE_URL}/get/industries`, {
    headers: authHeaders(),
  });

export const getCompanySizes = () =>
  axiosInstance.get(`${API_BASE_URL}/company/size`, {
    headers: authHeaders(),
  });

export const getCountries = () =>
  axiosInstance.get(`${API_BASE_URL}/countries`, {
    headers: authHeaders(),
  });

export const getCompanies = (params = {}) =>
  axiosInstance.get(`${ADMIN_API_URL}/companies`, {
    headers: authHeaders(),
    params,
  });

export const createCompanyRequest = (formData) =>
  axiosInstance.post(`${ADMIN_API_URL}/companies`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const updateCompanyRequest = (companyId, formData) =>
  axiosInstance.post(`${ADMIN_API_URL}/companies/${companyId}`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const deleteCompanyRequest = (companyId) =>
  axiosInstance.delete(`${ADMIN_API_URL}/companies/${companyId}`, {
    headers: authHeaders(),
  });
